<style lang="less" scoped>
// .header_common_box {
//   // .nav_box {
//   //   font-size: 22px;
//   // }

  
// }
.ellipsis-multiline {
  max-width: 130px;
  overflow: hidden; // 超出的文本隐藏
  text-overflow: ellipsis; // 溢出用省略号显示
  white-space: nowrap;
}
</style>

<style>
.header_common_box .el-menu--horizontal>.el-submenu .el-submenu__title {
  font-size: 14px;
  font-weight: 600;
}

.header_common_box .el-menu--horizontal>.el-menu-item {
  font-size: 14px;
  font-weight: 600;
}

/* .header_common_box.bg_blue .header_common_box .el-menu--horizontal>.el-menu-item{
  color: #fff !important;
} */
</style>

<template>
  <div>
    <div class="header_common_box media_small_hide" :class="{ 'bg_blue': pageName == 'login' }">
      <div class="container_box">
        <div class="header_main">
          <div class="flex-start">
            <div class="logo_box" @click="$router.push('/')">
              <img v-if="pageName != 'login'" src="../assets/images/index_top_logo.png" alt="">
              <img v-else src="../assets/images/index_bot_logo.png" alt="">
            </div>
            <div class="nav_box">
              <!-- text-color="#303133" -->
              <el-menu :default-active="activeIndex" :text-color="color" background-color="transparent"
                class="el-menu-demo" mode="horizontal" @select="routePath">
                <!-- <el-menu-item index="/" indexPath="/">首页</el-menu-item>
                    <el-menu-item index="/shed-index" indexPath="/shed-index/shed-news">公棚</el-menu-item>
                    <el-menu-item index="/breeding-center" indexPath="/breeding-center/breeding-news">育种中心</el-menu-item>
                    <el-menu-item index="#">拍卖</el-menu-item>
                    <el-menu-item index="/group-introduce">关于我们</el-menu-item> -->
                <el-menu-item v-for="(item, key) in NavList" :key="key" :index="item.routerPath">{{ item.name
                  }}</el-menu-item>
                <!-- <template v-for="(item,key) in NavList">
                    <el-menu-item :key="key" v-if="!item.children" :index="item.routerPath">{{ item.name }}</el-menu-item>
                      <el-submenu v-else :index="key" :key="key + '1'">
                        <template slot="title">
                            <span>{{ item.name }}</span>
                          </template>
                      <el-menu-item v-for="(list,i) in item.children" :key="i" :index="list.routerPath">{{ list.name }}</el-menu-item>
                    </el-submenu>
                </template> -->
              </el-menu>
            </div>
            <div class="search_box">
              <!-- <div class="el-icon-search" :class="{'color_white':pageName=='login'}" @click="getSearch()"></div> -->
              <el-input placeholder="搜一搜" v-model="searchValue" @keyup.enter.native="getSearch()">
                <span slot="suffix" class="el-icon-search" @click="getSearch()"></span>
              </el-input>
            </div>
            <div style="margin-left: 25px;">
              <el-button type="danger" @click="download()" size="mini">下载APP</el-button>
            </div>
          </div>
          <div class="login_btn" v-if="!token">
            <div class="btn_item" :class="{ 'bg_white': pageName == 'login' }" @click="$router.push('/login')">登录</div>
            <div class="btn_item" :class="{ 'bg_white': pageName == 'login' }" @click="$router.push('/register')">注册</div>
          </div>
          <div class="user_box" v-else>
            <div class="main" @click="$router.push('/member-index')">
              <div class="avatar_box">
                <img v-if="userInfo.avatar" :src="userInfo.avatar" alt="">
                <img v-else src="../assets/images/avatar.jpg" alt="">
              </div>
              <div class="name ellipsis-multiline">
                <!-- <v-clamp :max-lines="1"></v-clamp> -->
                {{ userInfo.nickName }}
              </div>
            </div>
            <div class="pop_box" @click="quite">退出</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端header -->
    <div class="mobile_header_box media_big_hide">
      <div class="header_box">
        <router-link to="/" class="logo"><img src="../assets/images/index_top_logo.png" alt=""></router-link>
        <div class="btn_list">
          <div class="el-icon-search search_btn" @click="$router.push('/search')"></div>
          <div class="btn" @click="showDraw"><img src="../assets/images/menu.png" alt=""></div>
        </div>
      </div>
    </div>
    <el-drawer title="导航" class="mobile_right_nav" :visible.sync="drawer" size="60%" :with-header="false">
      <div class="draw_main">
        <el-menu :default-active="this.$route.path" :default-openeds="['0']" class="menu_box" unique-opened
          @open="handleOpen" router @close="handleClose" @select="routeH5Path">
          <template v-for="(item, key) in NavList">
            <el-menu-item :key="key" v-if="!item.children" :index="item.routerPath">{{ item.name }}</el-menu-item>
            <el-submenu v-else :index="key + ''" :key="key + '1'">
              <template slot="title">
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item v-for="(list, i) in item.children" :key="i" :index="list.routerPath">{{ list.name
                }}</el-menu-item>
            </el-submenu>
          </template>

          <!-- <el-menu-item index="/">
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/shed-index">公棚</el-menu-item>
        <el-menu-item index="/breeding-center">育种中心</el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <span class="el-dropdown-link">鸽业介绍</span>
          </template>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <span>育种中心</span>
          </template>
          <el-menu-item index="/breeding-center/breeding-news">最新动态</el-menu-item>
          <el-menu-item index="/breeding-center/breeding-introduce">育种中心介绍</el-menu-item>
          <el-menu-item index="/breeding-center/breeding-engineering">六信工程</el-menu-item>
          <el-menu-item index="/breeding-center/breeding-match1">国内赛事</el-menu-item>
          <el-menu-item index="/breeding-center/breeding-match2">欧洲赛事</el-menu-item>
          <el-menu-item index="/breeding-center/pigeon-appreciate">邢小信藏鸽</el-menu-item>
          <el-menu-item index="/breeding-center/honour-halls">荣誉殿堂</el-menu-item>
          <el-menu-item index="/breeding-center/pair-list">金牌配对</el-menu-item>
          <el-menu-item index="/breeding-center/pigeon-share">鸽经分享</el-menu-item>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <span>爱心公棚</span>
          </template>
          <el-menu-item index="/shed-index/shed-news">最新动态</el-menu-item>
          <el-menu-item index="/shed-index/shed-introduce">公棚介绍</el-menu-item>
          <el-menu-item index="/shed-index/shed-engineering">六信工程</el-menu-item>
          <el-menu-item index="/shed-index/match-regulation">赛事规程</el-menu-item>
          <el-menu-item index="/shed-index/honour-halls">荣誉殿堂</el-menu-item>
          <el-menu-item index="/shed-index/results-enquiry">成绩查询</el-menu-item>
          <el-menu-item index="/shed-index/specify-query">指定查询</el-menu-item>
          <el-menu-item index="/shed-index/videos">视频</el-menu-item>
          <el-menu-item index="/shed-index/pictures">图片</el-menu-item>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <span>青年队</span>
          </template>
          <el-menu-item index="/shed-youth/shed-news">最新动态</el-menu-item>
          <el-menu-item index="/shed-youth/shed-introduce">公棚介绍</el-menu-item>
          <el-menu-item index="/shed-youth/shed-engineering">六信工程</el-menu-item>
          <el-menu-item index="/shed-youth/match-regulation">赛事规程</el-menu-item>
          <el-menu-item index="/shed-youth/honour-halls">荣誉殿堂</el-menu-item>
          <el-menu-item index="/shed-youth/results-enquiry">成绩查询</el-menu-item>
           <el-menu-item index="/shed-youth/specify-query">指定查询</el-menu-item>
          <el-menu-item index="/shed-youth/videos">视频</el-menu-item>
          <el-menu-item index="/shed-youth/pictures">图片</el-menu-item>
        </el-submenu>
        <el-submenu index="9">
          <template slot="title">
            <span>春棚</span>
          </template>
          <el-menu-item index="/shed-spring/shed-news">最新动态</el-menu-item>
          <el-menu-item index="/shed-spring/shed-introduce">公棚介绍</el-menu-item>
          <el-menu-item index="/shed-spring/shed-engineering">六信工程</el-menu-item>
          <el-menu-item index="/shed-spring/match-regulation">赛事规程</el-menu-item>
          <el-menu-item index="/shed-spring/honour-halls">荣誉殿堂</el-menu-item>
          <el-menu-item index="/shed-spring/results-enquiry">成绩查询</el-menu-item>
          <el-menu-item index="/shed-spring/specify-query">指定查询</el-menu-item>
          <el-menu-item index="/shed-spring/videos">视频</el-menu-item>
          <el-menu-item index="/shed-spring/pictures">图片</el-menu-item>
        </el-submenu> -->
          <el-submenu index="8" v-if="token">
            <template slot="title">
              <span class="nav_item">
                <div class="avatar">
                  <img v-if="userInfo.avatar" :src="userInfo.avatar" alt="">
                  <img v-else src="../assets/images/avatar.jpg" alt="">
                </div>
                <span class="name ellipsis-multiline">
                  {{ userInfo.nickName }}
                </span>
              </span>
            </template>
            <el-menu-item index="/member-index/account-info">账号资料</el-menu-item>
            <el-menu-item v-if="type == 2" index="/member-index/agent-greenhouse">代理专属通道</el-menu-item>
            <el-menu-item index="/member-index/my-events">我的赛事</el-menu-item>
            <!-- <el-menu-item v-if="type != 2" index="/member-index/myPigeon">我的赛鸽</el-menu-item>
            <el-menu-item v-if="type != 2" index="/member-index/my-appointment">预约交鸽</el-menu-item>
            <el-menu-item v-if="type != 2" index="/member-index/choice-shed">预约探视</el-menu-item>
            <el-menu-item v-if="type != 2" index="/member-index/elite-event">精英赛</el-menu-item>
            <el-menu-item v-if="type != 2" index="/member-index/designated-game">王者争霸赛</el-menu-item>
            <el-menu-item v-if="type != 2" index="/member-index/group-split">团体分组</el-menu-item>
            <el-menu-item v-if="type != 2" index="/member-index/over-time">加站赛</el-menu-item>
            <el-menu-item v-if="type != 2" index="/member-index/my-events">我的赛事</el-menu-item>
            <el-menu-item index="/member-index/account-shed">我的账户</el-menu-item>
            <el-menu-item index="/member-index/slow-home">迟归鸽</el-menu-item>
            <el-menu-item index="/member-index/refund">赛鸽退费</el-menu-item> -->
          </el-submenu>
        </el-menu>
        <div style="display: flex;justify-content: center;align-items: center;">
          <el-button type="danger" @click="download()">下载APP</el-button>
        </div>
        <div v-if="!token">
          <div class="btn_box btn_box1" @click="$router.push('/login')">登录</div>
          <div class="btn_box" @click="$router.push('/register')">注册</div>
        </div>
        <div v-else>
          <div class="btn_box" @click="quite">退出</div>
        </div>
      </div>
    </el-drawer>
  </div>

</template>
<script>
import common from "../api/common";
import login from "../api/login.js";
import shedIndex from "../api/shed-index";

export default {
  props: ['pageName','NavList'],
  name: 'index',
  data() {
    return {
      activeIndex: '/',
      searchValue: '',
      drawer: false,
      type: 0,
      color: '',
      shedId: 0
    }
  },
  watch: {
    '$route'(to, from) {
      //跳转路由时关闭右侧弹出
      let name = this.$route.path.split('/');
      this.activeIndex = '/' + name[1];
      this.drawer = false;
      this.searchValue = '';
      if (to.name == 'login' || to.name == 'register') {
        this.color = '#fff';
      } else {
        this.color = '#303133'
      }
    },
    drawer(val) {
      this.$store.dispatch('user/saveIsDrawer', this.drawer)
    },
    types() {
      this.type = this.$store.state.user.userInfo.type
      console.log(this.type)
    }
  },
  methods: {
    // 下载APP
    download() {
       //定义一个路径
       const href = this.$router.resolve({
          path: `/qr-code`
      }).href;
      //打开新的页面 到 href 这个页面
      window.open(href, "_blank");
    },
    getNav() {
      common.getNav().then((res) => {
        this.NavList = res.data;
        console.log(this.NavList)
        this.$store.dispatch("user/saveNavList", JSON.stringify(res.data));
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          if (this.$route.path.indexOf(element.routerName) != -1) {
            let children = element.children ? JSON.stringify(element.children) : '';
            this.$store.dispatch("user/saveChildren", children);
            let arr = element.children ? element.children : [];
            for (let j = 0; j < arr.length; j++) {
              const row = arr[j];
              if (row.routerName.indexOf(this.$route.name) != -1) {
                this.$store.dispatch("user/saveCategoryId", row.id);
                this.$store.dispatch("user/saveShedPath", row.routerPath);
              }
            }
          }
        }
      });
    },
    routePath (name, keyPath) {
      let obj = this.NavList.filter(item => item.routerPath == name)[0];
      if (name === '#') {
        window.open(obj.routerComponent);
        return
      }
      this.activeIndex = name;
      let children = obj.children ? JSON.stringify(obj.children) : '';
      this.$store.dispatch("user/saveChildren", children);
      this.$store.dispatch('user/saveShedPath');
      this.$store.dispatch("user/saveShedId", this.shedId);


      if (obj.children) {
        this.$store.dispatch("user/saveCategoryId", obj.children[0].id);
        this.$store.dispatch("user/saveShedPath", obj.children[0].routerPath);
        this.$router.push({ path: obj.children[0].routerPath });
      } else {
        this.$router.push({ path: name });
      }
      
    },
    routeH5Path(name, keyPath) {
      console.log(name)
      let arr = this.NavList.flatMap(item => item.children);
      let obj = arr.filter(item => item != null && item.routerPath == name)[0];
      if (name === '#') {
        window.open('https://kaiergeye.com/');
        return
      }
      this.activeIndex = name;
      this.$store.dispatch('user/saveShedPath', name);
      this.$store.dispatch("user/saveCategoryId", obj.id);
      this.$router.push({ path: name });
    },
    getSearch() {
      this.$router.push({ path: '/search', query: { searchKey: this.searchValue } });
      // let routeData = this.$router.resolve({
      //     name: 'search',
      //     query: {searchKey: this.searchValue},
      // })
      // window.open(routeData.href, '_blank')
    },
    // 退出登录
    quite() {
      this.$confirm('确定要退出登录吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        login.logout();
        this.$store.dispatch("user/saveLoginPath", '/');
        this.$store.dispatch('user/clearUserInfo');
        if (this.$route.path != '/') {
          this.$router.replace('/');
        }
        this.$message.success('退出成功')
      }).catch(() => { });
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    showDraw() {
      this.drawer = true;
    }
  },
  created() {
    // this.getNav();
    // type身份 ( 1管理员2代理3系统用户4司机 )
    if (this.$store.state.user.userInfo === null) {
      this.$store.dispatch("user/saveUserInfo", {});
    }
    this.type = this.$store.state.user.userInfo.type;
    
    let name = this.$route.path.split('/');
    this.activeIndex = '/' + name[1];

    shedIndex.getShedHosts().then(res=>{
      if(res){
        if (res.data.length > 0) {
          console.log(this.ShedId)
          if (!this.ShedId) {
            this.$store.dispatch("user/saveShedId", res.data[0].shedId);
            
          }
          this.shedId = res.data[0].shedId;
        }
      }
    });
  },
  computed: {
    currentPage() {
      let path = this.$route.path.split('/');
      return path[1];
    },
    types() {
      return this.$store.state.user.userInfo.type
    },
    currentPage1() {   //当前在哪个模块
      return this.$route.path.split('/')[1]
    },
    currentPage2() {   //当前在哪个页面
      return this.$route.path.split('/')[2]
    },
    userInfo() {
      return this.$store.getters['user/userInfo'];
    },
    token() {
      return this.$store.getters['user/token'];
    },
    ShedId(){
        return this.$store.getters['user/ShedId'];
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/header-common.vue